import ContactForm from "./ContactForm";
import ContactContext from "./ContactContext";

const Contacts = () => {
  return (
    <section className="contact">
      <div className="contact__container container">
        <ContactContext/>
        <ContactForm />
      </div>
    </section>
  );
};

export default Contacts;
